import { render, staticRenderFns } from "./SignUpStepEmail.vue?vue&type=template&id=6fb6a7a6"
import script from "./SignUpStepEmail.vue?vue&type=script&lang=js"
export * from "./SignUpStepEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports